import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_END_POINT } from '../pages/Utils/Constant';
import logoimg from "../assets/rootimg/astrotellerlogo.png";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CommonNavbar from '../pages/CommonNavbar';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [validationError, setValidationError] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setValidationError('');
        setSuccessMessage('');

        // Validate email
        if (!email || !validateEmail(email)) {
            setValidationError('Please enter a valid email address');
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(`${API_END_POINT}auth/forgot-password`, {
                email
            });

            // Store email in session for verification page
            sessionStorage.setItem('tempEmail', email);

            // Show success message
            setSuccessMessage('Check your email to reset your password.');
            toast.success('Reset Link sent successfully!', {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });

            // Disable the button for 5 minutes
            setIsDisabled(true);
            setTimeout(() => setIsDisabled(false), 5 * 60 * 1000); // 5 minutes
        } catch (error) {
            console.error('Error:', error.response?.data || error.message);
            toast.error(error.response?.data?.message || 'Failed to send Reset Link. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-white to-success/40">
            <CommonNavbar />
            <ToastContainer />
            <div className="w-full max-w-md p-8 mt-10 bg-white rounded-lg shadow-lg">
                {/* Logo */}
                <div className="flex justify-center mb-2">
                    <div className="w-[75%] h-auto mx-auto">
                        <img src={logoimg} alt="Logo" className="w-full h-full object-contain" />
                    </div>
                </div>

                {/* Heading */}
                <h1 className="text-lg font-semibold text-center text-secondary">
                    Forgot Password?
                </h1>
                <p className="text-gray-600 text-center mb-4">
                    Enter your email to reset your password
                </p>

                <form onSubmit={handleSubmit} className="space-y-6">
                    {/* Email Input */}
                    <div>
                        <input
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#6366f1]"
                        />
                        {validationError && (
                            <p className="text-red-500 text-sm mt-1">{validationError}</p>
                        )}
                    </div>

                    {/* Success Message */}
                    {successMessage && (
                        <p className="text-green-500 text-sm text-center">{successMessage}</p>
                    )}

                    {/* Submit Button */}
                    <button
                        type="submit"
                        disabled={loading || isDisabled}
                        className={`w-full py-3 rounded-md font-medium transition-colors ${loading || isDisabled
                                ? 'bg-gray-300 cursor-not-allowed'
                                : 'bg-black text-white hover:bg-secondary'
                            }`}
                    >
                        {loading ? "Sending..." : "Send Reset Link"}
                    </button>

                    {/* Back to Login Link */}
                    <p className="text-gray-600 text-center">
                        Remember your password?{" "}
                        <Link to="/login" className="text-blue-500 font-medium">
                            Back to Login
                        </Link>
                    </p>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;
